// extracted by mini-css-extract-plugin
module.exports = {"fallback":"InputFallback__fallback___1ibw1","flick":"InputFallback__flick___2AIxm"};